import React from "react";
import { oneOfType, arrayOf, node, string, func, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { CloseIcon } from "../../basic/icons/close-icon";

import "./topArrowContainer.m.css";

const TopArrowContainer = ({ children, closeView, className = "", publisherAttributes }) => (
  <div styleName={`top-arrow-container ${publisherAttributes.lang}-top-arrow-container`} className={className}>
    <div styleName="close-wrapper" className="remove-wrapper">
      <div styleName="close-icon" onClick={closeView}>
        <CloseIcon width={30} height={30} color="#555555" />
      </div>
    </div>

    {children}
  </div>
);

TopArrowContainer.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  closeView: func,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(TopArrowContainer);
